module.exports = __webpack_public_path__ + "img/Oeste.21db087a.svg";